







































































































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { Notification } from './Notification';
import { Location } from '@/Stores/UserStore';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { LocationLookupType, ILookupType } from '@/Stores/LookupStore';

const NotificationsAdmin = Vue.extend({
    async beforeMount() {
        const locations: Location[] = await this.$typedStore.modules.userModule.actions.getAllowedLocations();
        this.allowedLocations = locations;
        this.selectedLocation = this.allowedLocations
            .find(item => item.urlSegment.toUpperCase() === this.location.toUpperCase())
            || null;
        if (this.selectedLocation) {
            this.selectedLocationId = this.selectedLocation.locationId;
        }
    },
    props: ['location'],
    data() {
        return {
            filterExpired: false,
            editNotification: { isaddNotification: false } as any as Notification,
            addNotification: { isaddNotification: true } as any as Notification,
            notificationsAdmin: [] as Notification[],
            noteTypeLkup: [] as ILookupType[],
            selectedCodeDescription: null,
            loadingNotifications: {} as { [recID: string]: boolean },
            validationErrors: {} as { [key: string]: string[] },
            selectedLocationId: null as number | null,
            selectedLocation: null as Location | null,
            selectedLocationDBName: '',
            selectedLocations: [],
            allowedLocations: [] as Location[]
        };
    },
    methods: {
        editing(notification: Notification) {
            if ((notification as any).isaddNotification) {
                return true;
            }
            else if (this.editNotification && this.editNotification.recID
                && !(this.editNotification as any).isaddNotification) {
                return this.editNotification.recID === notification.recID;
            }
            else {
                return false;
            }
        },
        edit(notification: Notification) {
            this.editNotification = { ...notification };
        },
        add() {
            this.editNotification = { ...this.addNotification };
        },
        async save(notification: Notification) {
            Vue.set(this.loadingNotifications, notification.recID, true);
            try {
                let url = `${this.location}/NotificationsAdmin/AddNotification`;
                if ((notification as any).isaddNotification) {
                    await VatsAPI.post(url, notification);
                }
                else {
                    url = `/${this.location}/NotificationsAdmin/UpdateNotification`;
                    await VatsAPI.post(url, notification);
                }

                await this.refreshNotifications();
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                Vue.set(this.loadingNotifications, notification.recID, false);
            }

            this.cancelEdit();
        },
        async deleteNotification(notification: Notification) {
            const deleteConfirmMessage = this.$i18n.t('admin.notificationManagement.deleteConfirmMessage').toString() + `, ${notification.recID}?`;
            const deleteConfirmTitle = this.$i18n.t('admin.notificationManagement.deleteConfirmTitle').toString();
            const deleteButton = this.$i18n.t('common.delete').toString();
            const cancelButton = this.$i18n.t('common.cancel').toString();

            const confirmDelete = await this.$bvModal.msgBoxConfirm(
                deleteConfirmMessage,
                {
                    title: deleteConfirmTitle,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'info',
                    okTitle: deleteButton,
                    cancelTitle: cancelButton,
                    centered: true
                }
            );
            if (confirmDelete) {
                try {
                    Vue.set(this.loadingNotifications, notification.recID, true);
                    await VatsAPI.post(`${this.location}/NotificationsAdmin/DeleteNotification`, notification);
                    await this.refreshNotifications();
                    Vue.set(this.loadingNotifications, notification.recID, false);
                }
                catch (e) {
                    this.$bvToast.toast(this.$i18n.t('admin.notificationManagement.deleteUserError').toString(), {
                        title: this.$i18n.t('common.error').toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
            }
        },
        cancelEdit() {
            this.editNotification = { isaddNotification: false } as any as Notification;
            this.addNotification = { isaddNotification: true } as any as Notification;
        },
        async refreshNotifications() {
            try {
                if (this.filterExpired) {
                    this.notificationsAdmin = (await VatsAPI.get<Notification[]>(`/${this.location}/NotificationsAdmin/GetFilteredNotifications`)).data;
                }
                else {
                    this.notificationsAdmin = (await VatsAPI.get<Notification[]>(`/${this.location}/NotificationsAdmin/GetNotifications`)).data;
                }
                for (const notification of this.notificationsAdmin) {
                    notification.startDate = new Date(notification.startDate);
                    notification.endDate = new Date(notification.endDate);
                }
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.notificationManagement.refreshUserError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async locationChanged() {
            await this.refreshNotifications();
        },
        getNotificationStatusClass(notification: Notification): string {
            let statusClass: string = '';
            const todayDate = new Date();
            if (notification.endDate < todayDate) {
                statusClass = 'expired';
            }
            return statusClass;
        },
    },
    async mounted() {
        this.refreshNotifications();
        const payload = { lookupType: LocationLookupType.NoteType, location: this.location };
        const lookups = await this.$typedStore.modules.lookupsModule.actions.getLocationLookups(payload);
        for (const code in lookups) {
            if (lookups[code]) {
                this.noteTypeLkup.push(lookups[code]);
            }
        }
    }
});

export default NotificationsAdmin;
